import { render, staticRenderFns } from "./IndividualSupport.vue?vue&type=template&id=7fb07913"
import script from "./IndividualSupport.vue?vue&type=script&lang=js"
export * from "./IndividualSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports